/**
 * This tab's copy of the parent gate (SPEC 2.4, T3.9c). The api decides: it asks the adult
 * question, opens the parent routes of this session for 15 minutes and closes them when a child
 * is picked. The tab remembers the end time only to know when to ask again, and closes its copy
 * whenever the api answers PARENT_LOCKED.
 */
const KEY = "mb-parent-until";
export const GATE_CLOSED = "mb-parent-closed";

export function gateUntil(): number {
  try {
    return Number(sessionStorage.getItem(KEY) ?? 0);
  } catch {
    return 0;
  }
}

export const gateOpen = () => gateUntil() > Date.now();

export function openGate(seconds: number) {
  try {
    sessionStorage.setItem(KEY, String(Date.now() + seconds * 1000));
  } catch {
    /* storage blocked: the gate simply asks again next time */
  }
}

export function closeGate() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* nothing kept */
  }
  window.dispatchEvent(new Event(GATE_CLOSED));
}
